import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import {
    currentClient,
    useCurrentClient,
    useCurrentUser,
    useAccessToken,
} from '@alli/frontend-common';
import SetDefaultCurrentClient from './components/SetDefaultCurrentClient';
import SetClientFromUrl from './components/SetClientFromUrl';

export default function Root(props) {
    const accessToken = useAccessToken();
    const currentUser = useCurrentUser();
    const localCurrentClient = useCurrentClient();

    return (
        <BrowserRouter>
            <Routes>
                <Route
                    path="/client/:clientIdOrSlug/*"
                    element={
                        <SetClientFromUrl
                            currentClient={currentClient}
                            currentUser={currentUser}
                            accessToken={accessToken}
                            localCurrentClient={localCurrentClient}
                        />
                    }
                />
                <Route
                    path="*"
                    element={
                        <SetDefaultCurrentClient
                            currentClient={currentClient}
                            currentUser={currentUser}
                            localCurrentClient={localCurrentClient}
                        />
                    }
                />
            </Routes>
        </BrowserRouter>
    );
}
